import axios from 'axios'

export const viaCep = async zipCode => {
  let result = null
  if (zipCode !== null && zipCode.replace('-', '').replace('_', '').length > 7) {
    const url = `https://viacep.com.br/ws/${zipCode.replace('-', '').replace('_', '')}/json/`
    result = await axios.get(url)
    result = result.data
  }
  return result
}

export const mapBox = async addressData => {
  try {
    let url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
    const mapboxUrl =
      'pk.eyJ1IjoiZ2Vyc29uYSIsImEiOiJjanpiYXJhY3MwMmxiM21ueDR2azg1dTdtIn0.l1ZmxsY7H0j-HO4_DcaPag'

    let latLong = {
      lat: 0,
      long: 0
    }

    const { address, city, uf, number } = addressData
    let search = address.replace(/ /g, '+')

    if (number.length > 0) {
      search = `${address.replace(/ /g, '+')}+${number}`
    }

    if (city.length > 0 && uf.length > 0 && number.length < 1) {
      search = `${uf}+${city.replace(/ /g, '+')}+${address.replace(/ /g, '+')}`
    } else if (city.length > 0 && uf.length > 0 && number.length > 0) {
      search = `${uf}+${city.replace(/ /g, '+')}+${address.replace(/ /g, '+')}+${number}`
    }
    url = addressData.address !== '' && `${url + search}.json?access_token=${mapboxUrl}`

    const response = url && (await axios.get(url))

    if (response.data !== undefined) {
      latLong = {
        lat: response.data.features[0].geometry.coordinates[1],
        long: response.data.features[0].geometry.coordinates[0]
      }
    }

    return response && latLong
  } catch (e) {
    console.log(e)
  }
}
